import React, { Component, Fragment } from 'react';
import { Trans } from '@lingui/macro';
import { connect } from 'react-redux';
import { CPF } from 'gerador-validador-cpf/dist/js/CPF';


// COMPONENTS
import { Typography, Accordion, Button, Card, CartSummary, CheckBox, Column, TextInput, RadioButton } from 'components';
import Dropdown from '../../../components/Dropdown/';
import Tabs from '../../../components/Tabs/';
import Row from '../../../components/Row/';

/* REDUX */
import {
  formatRegisteredCards,
  removeSpaceCreditCardNumber,
} from '../utils/creditCardUtils';
import * as actions from '../../../redux/actions';
import * as paymentMethods from './../../../settings/_paymentMethodsSettings';

/* REDUX */
import * as routes from './../../../settings/_routesSettings';
import { formatCartItems, formatFloatToReal } from '../utils/orderUtils';
import { removeMaskInputValue } from '../../../utils/textTransformations';
import InputValidation from '../../../utils/InputValidation';
import { history } from '../../../routers/AppRouter';
import { STS20001, STS20002, STS20003, STS20004 } from '../../../settings/_paymentStatusSettings';

class Checkout extends Component {

  /**
   * 
   * TODO:
   *  QUANDO FOREM ADICIONADOS MAIS MÉTODOS DE PAGAMENTO,
   *  CRIAR LÓGICA PARA CAPTURAR DADOS DA API E ALTERNAR
   *  ENTRE OS RADIOBUTTONS / FAZER DISPLAY APENAS DOS 
   *  MÉTODOS AUTORIZADOS
   * 
   *  OS DADOS DE PARCELA ESTÃO MOCKADOS (SPRINT 08),
   *  QUANDO ESTIVEREM DISPONÍVEISNA API, SERÁ 
   *  NECESSÁRIO CRIAR TODA A LÓGICA PARA RECEBE-LOS E
   *  APLICA-LOS
   * 
   */

  state = {
    selectedMethod: 'credit_card',
    selectedCardInput: 'registered-card',
    creditCardList: [],
    readyToSubmit: false,
    saveCard: false,
    ordersTimer: 5000,
    loading: false,

    card_number: {
      value: '',
      isValid: true,
      message: '',
    },
    card_holder_name: {
      value: '',
      isValid: true,
      message: '',
    },
    card_expiration_date_month: {
      value: '',
      isValid: true,
      message: '',
    },
    card_expiration_date_year: {
      value: '',
      isValid: true,
      message: '',
    },
    card_cvv: {
      value: '',
      isValid: true,
      message: '',
    },
    titular_cpf: {
      value: '',
      isValid: true,
      message: '',
    },
    titular_date_birth: {
      value: '',
      isValid: true,
      message: '',
    },
  }

  cardTabs = [
    {
      title: (<Trans>Cartão Cadastrado</Trans>),
      id: 'registered-card',
    },
    {
      title: (<Trans>Novo Cartão</Trans>),
      id: 'new-card',
    },
  ]

  mockPacelas = orderTotal => {
    return [
      {
        name: (`1x de R$${formatFloatToReal(orderTotal)}`),
        id: '1',
      },
    ];
  }

  componentDidUpdate = (prevProps) => {
    this.checkRequiredFields();
    if (prevProps.creditCards !== this.props.creditCards) {
      this.handleMultipleCards();
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.onGetCreditCards(this.props.userSlug, this.props.actualProfile);
  }

  handleSelectMethod = (value) => {
    this.setState({ selectedMethod: value });
  }

  handleSelectTab = (value) => {
    this.setState({
      selectedCardInput: value,
      card_number: {
        ...this.state.card_number,
        value: '',
      },
      card_expiration_date_month: {
        ...this.state.card_number,
        value: '',
      },
      card_expiration_date_year: {
        ...this.state.card_number,
        value: '',
      },
      card_cvv: {
        ...this.state.card_number,
        value: '',
      },
    });
  }

  handleMultipleCards = () => {
    if (this.props.creditCards.length > 0) {
      const cardFormatedList = formatRegisteredCards(this.props.creditCards);
      this.setState({
        creditCardList: cardFormatedList,
        selectedCardInput: 'registered-card',
      });
    } else {
      this.setState({ selectedCardInput: 'new-card' });
    }
  }

  handleRegisteredCardNumber = (cardId) => {
    this.setState({
      card_number: {
        ...this.state.card_number,
        value: cardId,
        isValid: true,
        message: '',
      },
    });
  }

  handleCardNumberInput = (e) => {
    let inputValue = removeMaskInputValue(
      removeSpaceCreditCardNumber(e.target.value)
    );
    let validation = new InputValidation(inputValue, 'creditCardNumber').validate();
    this.setState({
      card_number: {
        ...this.state.card_number,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardHolderInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'name').validate();
    this.setState({
      card_holder_name: {
        ...this.state.card_holder_name,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardMonthInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'month').validate();
    this.setState({
      card_expiration_date_month: {
        ...this.state.card_expiration_date_month,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardYearInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'year').validate();
    this.setState({
      card_expiration_date_year: {
        ...this.state.card_expiration_date_year,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardCvvInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'cvv').validate();
    this.setState({
      card_cvv: {
        ...this.state.card_cvv,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardCpfInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'cpf').validate();
    this.setState({
      titular_cpf: {
        ...this.state.titular_cpf,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleCardBirthInput = (e) => {
    let inputValue = removeMaskInputValue(e.target.value);
    let validation = new InputValidation(inputValue, 'date').validate();
    this.setState({
      titular_date_birth: {
        ...this.state.titular_date_birth,
        value: inputValue,
        isValid: validation.success,
        message: validation.message,
      },
    });
  }

  handleSaveCheckbox = () => {
    this.setState({ saveCard: !this.state.saveCard });
  }

  checkRequiredFields = () => {
    let readyToSubmit = true;

    let requiredStates = [];

    switch (this.state.selectedMethod) {
      /**
       * VERIFY PAYMENT METHOD
       */
      case 'credit_card':

        if (this.state.selectedCardInput === 'new-card') {
          requiredStates = [
            'card_number',
            'card_holder_name',
            'card_expiration_date_month',
            'card_expiration_date_year',
            'card_cvv',
            'titular_cpf',
            'titular_date_birth',
          ];
        } else {
          requiredStates = [
            'card_number',
            'card_cvv',
          ];
        }
        break;

      default:
        break;
    }

    requiredStates.map(rq => {
      if (this.state[rq].value === '' ||
        this.state[rq].value === undefined ||
        this.state[rq].value === null ||
        this.state[rq].isValid === false) {
        readyToSubmit = false;
      }
      return readyToSubmit;
    });

    if (readyToSubmit !== this.state.readyToSubmit) {
      this.setState({ readyToSubmit });
    }

    return readyToSubmit;
  }

  onSubmit = async () => {

    let paymentPayload;
    let paymentStatus = {
      cardRegisterSuccess: null,
      paymentSucess: false,
      paymentConfirmed: false,
    };

    switch (this.state.selectedMethod) {
      /**
       * VERIFY PAYMENT METHOD
       */
      case 'credit_card':
        if (this.state.selectedCardInput === 'new-card') {
          /**
           * VERIFY IF IT'S A NEW CARD OR A REGISTERED ONE
           */
          const titular_cpf = CPF.format(this.state.titular_cpf.value, 'digits');
          const card_expiration_date = () => {
            return (this.state.card_expiration_date_month.value +
              this.state.card_expiration_date_year.value.slice(-2)
            );
          };

          const registerPayload = {
            "cpf_holder": titular_cpf,
            "card_number": this.state.card_number.value,
            "card_holder_name": this.state.card_holder_name.value,
            "card_expiration_date": card_expiration_date(),
            "card_cvv": this.state.card_cvv.value,
          };

          paymentPayload = {
            ...registerPayload,
            "titular_cpf": titular_cpf,
            "titular_date_birth": this.state.titular_date_birth.value,
            "payment_method": this.state.selectedMethod,
          };
          delete paymentPayload["cpf_holder"];

          //VERIFY IF THE CARD IS GOING TO BE SAVED
          if (this.state.saveCard) {
            await this.props.onSaveCreditCard(this.props.userSlug, this.props.actualProfile, registerPayload)
              .then(() => {
                //deu certo pra salvar o cartão
                this.props.onSetPayment({ cardRegisterSuccess: true });
              })
              .catch(err => {
                //deu erro pra salvar o cartão e o cardRegisterSuccess vai virar false
                console.log(err);
                this.props.onSetPayment({ cardRegisterSuccess: false });
              });
          } else {
            //CREDIT CARD WILL NOT BE SAVED
            this.props.onSetPayment({ cardRegisterSuccess: null });
          }
        } else {
          paymentPayload = {
            "card_id": this.state.card_number.value,
            "card_cvv": this.state.card_cvv.value,
            "payment_method": this.state.selectedMethod,
          };
        }

        //SEND THE CHECKOUT ORDER
        this.props.onCreateCheckout(this.props.orderId, paymentPayload)
          .then(() => {
            //GET THE UPDATED ORDER
            if (this.props.checkoutStatus === "OK") {
              this.getOrdersById(this.props.orderId);
            } else if (this.props.checkoutMessage && this.props.checkoutMessage.length > 0) {
              this.props.checkoutMessage.forEach(msg => {
                if (msg.info === "order_overbooking") {
                  this.props.onSetPayment({ overbooking: true });
                  history.push(routes.PAYMENT_RESPONSE);
                }
              });
            }
          });

        break;

      default:
        break;
    }
    return paymentStatus;
  }

  submitAndCallback = async () => {
    this.setState({ loading: true });
    await this.onSubmit();
  }

  getOrdersById = (id) => {
    //TIMER TO WAITING THE PAYMENT PROCESS PERIOD
    setTimeout(function () {
      this.props.onGetOrders(id)
        .then(() => {
          switch (this.props.orderStatus) {
            //WAITING PAYMENT
            //PROCESSING PAYMENT
            case STS20001:
            case STS20004:
              this.props.onSetPayment({ paymentConfirmed: false, paymentSucess: false });
              break;
            //PAYMENT OK
            case STS20002:
              this.props.onSetPayment({ paymentConfirmed: true, paymentSucess: true });
              break;
            //PAYMENT RECUSED
            case STS20003:
              this.props.onSetPayment({ paymentConfirmed: true, paymentSucess: false });
              break;
            //REDIRECT TO THE WAITING MESSAGE
            default:
              this.props.onSetPayment({ paymentConfirmed: false, paymentSucess: false });
          }
          history.push(routes.PAYMENT_RESPONSE);
        });
    }.bind(this), this.state.ordersTimer);
  }

  creditCard = () => {
    return (
      <div className="PaymentContainer__payment-method">
        <div className="PaymentContainer__payment-method__title">
          <RadioButton
            title={<Trans>Cartão de Crédito</Trans>}
            onClickRadioButton={this.handleSelectMethod}
            radioId="credit_card"
            selected={this.state.selectedMethod === 'credit_card'}
            value="credit_card"
          />
        </div>
        {
          this.state.creditCardList.length > 0 ? (
            <Fragment>
              <Row className="PaymentContainer__card-tabs">
                <Tabs tabs={this.cardTabs}
                  selectedItem={this.state.selectedCardInput}
                  onSelectTab={this.handleSelectTab}
                />
              </Row>
              {
                this.state.selectedCardInput === 'registered-card' ?
                  this.registeredCardTab() : this.newCreditCard()
              }
            </Fragment>

          ) : this.newCreditCard()
        }
      </div>
    );
  }

  registeredCardTab = () => {
    return (
      <Row className="PaymentContainer__registered-card-form">
        <Column colWidth={12}>
          <Dropdown
            options={this.state.creditCardList}
            onSelect={(code) => this.handleRegisteredCardNumber(code)}
            placeholder="Selecione seu cartão*"
            name="card_number"
            dropDownOverflow={true}
          />
        </Column>
        <Column colWidth={3}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="CVV*"
            required={true}
            mask="111"
            name="card_cvv"
            onInputChange={(e) => this.handleCardCvvInput(e)}
            messageError={this.state.card_cvv.message}
            hasError={!this.state.card_cvv.isValid}
            value={this.state.card_cvv.value}
          />
        </Column>
        <Column colWidth={9}>
          <Dropdown
            options={this.mockPacelas(this.props.orderTotal)}
            onSelect={(code) => code}
            placeholder="Parcelas*"
            name="parcelas"
            preSelectedItem={this.mockPacelas(this.props.orderTotal)[0].id}
          />
        </Column>
      </Row>
    );
  }

  newCreditCard = () => {
    return (
      <Row className="PaymentContainer__new-card-form">
        <Column colWidth={12}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="Número do cartão*"
            required={true}
            mask="1111 1111 1111 1111"
            name="card_number"
            onInputChange={(e) => this.handleCardNumberInput(e)}
            messageError={this.state.card_number.message}
            hasError={!this.state.card_number.isValid}
            value={this.state.card_number.value}
          />
        </Column>
        <Column colWidth={12}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="Nome do titular*"
            required={true}
            name="card_holder_name"
            onInputChange={(e) => this.handleCardHolderInput(e)}
            messageError={this.state.card_holder_name.message}
            hasError={!this.state.card_holder_name.isValid}
            value={this.state.card_holder_name.value}
          />
        </Column>
        <Column colWidth={6}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="Mês de validade*"
            mask="11"
            required={true}
            name="card_expiration_date_month"
            onInputChange={(e) => this.handleCardMonthInput(e)}
            messageError={this.state.card_expiration_date_month.message}
            hasError={!this.state.card_expiration_date_month.isValid}
            value={this.state.card_expiration_date_month.value}
          />
        </Column>
        <Column colWidth={6}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="Ano de validade*"
            mask="1111"
            required={true}
            name="card_expiration_date_year"
            onInputChange={(e) => this.handleCardYearInput(e)}
            messageError={this.state.card_expiration_date_year.message}
            hasError={!this.state.card_expiration_date_year.isValid}
            value={this.state.card_expiration_date_year.value}
          />
        </Column>
        <Column colWidth={6}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="CVV*"
            required={true}
            mask="111"
            name="card_cvv"
            onInputChange={(e) => this.handleCardCvvInput(e)}
            messageError={this.state.card_cvv.message}
            hasError={!this.state.card_cvv.isValid}
            value={this.state.card_cvv.value}
          />
        </Column>
        <Column colWidth={6}>
          <Dropdown
            options={this.mockPacelas(this.props.orderTotal)}
            onSelect={(code) => code}
            placeholder="Parcelas*"
            name="parcelas"
            preSelectedItem={this.mockPacelas(this.props.orderTotal)[0].id}
          />
        </Column>
        <Column colWidth={12}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="CPF do titular do cartão*"
            required={true}
            mask="111.111.111-11"
            name="titular_cpf"
            onInputChange={(e) => this.handleCardCpfInput(e)}
            messageError={this.state.titular_cpf.message}
            hasError={!this.state.titular_cpf.isValid}
            value={this.state.titular_cpf.value}
          />
        </Column>
        <Column colWidth={12}>
          <TextInput
            inputHeight='4.8rem'
            placeholder="Data de nascimento*"
            required={true}
            mask="11/11/1111"
            name="titular_date_birth"
            onInputChange={(e) => this.handleCardBirthInput(e)}
            messageError={this.state.titular_date_birth.message}
            hasError={!this.state.titular_date_birth.isValid}
            value={this.state.titular_date_birth.value}
          />
        </Column>
        <Column colWidth={12}>
          <CheckBox isSle
            checkBoxId="save-card"
            onClickCheckBox={(selected) => this.handleSaveCheckbox(selected)}
            title={(<Trans>Salvar cartão</Trans>)}
            isSelected={this.state.saveCard}
          />
        </Column>
      </Row>
    );
  }

  render() {
    return (
      <div className="Checkout">
        <Row align='center'
          justify='center'
          margin='2rem 0 0'>
          <Typography align='mcenter-dleft'
            type='heading4'
            style={{ width: '100%' }}>
            <Trans>Pagamento</Trans>
          </Typography>
        </Row>
        <Row align='center'
          justify='center'
          margin='0 0 2rem'>
          <Typography align='mcenter-dleft'
            type='paragraph'
            color="grey-dark"
            style={{ width: '100%' }}>
            <Trans>Passo 2 de 3</Trans>
          </Typography>
        </Row>
        <Row>
          <Column colWidth={8}
            className="Checkout__payment-method">
            <Card classModifier="darkenBackground">
              <div className="PaymentContainer">
                <div className="PaymentContainer__title">
                  <Typography type="subtitle">
                    <Trans>
                      Escolha as opções abaixo:
                    </Trans>
                  </Typography>
                </div>
                <div className="PaymentContainer__payment-methods">
                  {
                    /**
                    * AQUI DEVE SER IMPLEMENTADO A LÓGICA PARA PAYMENT
                    * METHODS RETORNADOS DA API
                    */
                    ['PMT60001'].includes(paymentMethods.PMT60001) ?
                      this.creditCard() : null
                  }
                </div>
              </div>
            </Card>
          </Column>
          <Column colWidth={4}>
            <Row direction="column">
              <Row>
                <Accordion
                  title={(<Trans>Resumo da compra:</Trans>)}>
                  <CartSummary
                    discountValue={formatFloatToReal(this.props.orderDiscount)}
                    itemList={formatCartItems(this.props.orderItems)}
                    professionalName={this.props.orderProfessional}
                    sumValue={formatFloatToReal(this.props.orderTotal)}
                    totalValue={formatFloatToReal(this.props.orderTotal + this.props.orderDiscount)}
                  />
                </Accordion>
              </Row>
              <Row margin="15px 0">
                <Button text={(<Trans>FINALIZAR COMPRA</Trans>)}
                  onButtonClick={this.submitAndCallback}
                  disabled={!this.state.readyToSubmit}
                  loading={this.state.loading}
                />
              </Row>
            </Row>
          </Column>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    actualProfile: state.auth.userData.session.profile_active,
    orderDiscount: state.orders.discount,
    order: state.orders,
    orderId: state.orders.id,
    orderItems: state.orders.items,
    orderProfessional: state.orders.professionalName,
    orderStatus: state.orders.status,
    orderTotal: state.orders.total,
    creditCards: state.cards.creditCards,
    checkoutStatus: state.checkout.checkoutStatus,
    checkoutMessage: state.checkout.checkoutMessage,
    payment: state.payment,
    userSlug: state.auth.userData.username,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetOrders: (orderId) => dispatch(actions.getOrders(orderId)),
    onGetCreditCards: (userSlug, actualProfile) => dispatch(actions.getCreditCards(userSlug, actualProfile)),
    onSaveCreditCard: (userSlug, actualProfile, bodyConfig) => dispatch(actions.saveCreditCard(userSlug, actualProfile, bodyConfig)),
    onCreateCheckout: (orderId, paymentPayload) => dispatch(actions.createCheckout(orderId, paymentPayload)),
    onSetPayment: (paymentStatus) => dispatch(actions.setPayment(paymentStatus)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);